<template>
  <!-- Server-rendered HTML from limit_reached.locations(_paypal)_html.
       Content is fully controlled by Ruby i18n; no user input — safe for v-html.
       The contact-support anchor has id="js-open-intercom" which Intercom's
       custom_launcher_selector hooks into automatically. -->
  <AppAlert variant="warning">
    <!-- eslint-disable vue/no-v-html -->
    <span v-html="data.html" />
    <!-- eslint-enable vue/no-v-html -->
  </AppAlert>
</template>

<script setup>
import { AppAlert } from '@/components/ui'

defineProps({
  data: { type: Object, required: true }
})
</script>
